export default __webpack_public_path__ + "static/media/Favour_rounded.4ee375b0.png";